module.exports = __webpack_public_path__ + "img/close-mic.a488b182.png";